import React, { Component } from 'react';
import Sort from './Sort';
import Change from "./Change";
import {observer} from 'mobx-react';
import './TopLists.css';
import {Link} from "react-router-dom";

let formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 20,
});

@observer
class TopLists extends Component {
    constructor(props) {
        super(props);
        this.generateCoin = this.generateCoin.bind(this);
        this.getTopLists = this.getTopLists.bind(this);
    }

    generateCoin(coin) {
        let coinData = {
            name: coin.name,
            symbol: coin.symbol,
            volume: coin.volume,
            change: coin.change
        };

        let currency = this.props.appState.currency;
        let currencyPrefix = currency.prefix;
        let currencySuffix = currency.suffix;
        let routingLink = "/coin/" + coinData.symbol;

        return (
            <li key={'top-' + coinData.symbol} className=" top-list-coin clickable">
                <div>

                    <span className="name">
                        <Link to={routingLink}>
                        { coinData.name }
                        </Link>
                    </span>
                    <span className="change-container">
                        <Change title={'Volume: ' + currencyPrefix + formatter.format(coinData.volume) + currencySuffix} change={coinData.change} />
                    </span>
                </div>
            </li>
        )
    }


    // Gets top winners and losers
    getTopLists(coins) {
        const amountToShow = this.props.amount || 5;
        let topWinners = [];
        let topLosers = [];
        let compareFunc = Sort.compareManual("change", Sort.direction.descending);
        coins.sort(compareFunc);

        for (let i = 0; i < Math.min(coins.length, amountToShow); i++) {
            let coin = coins[i];
            if (coin.change <= 0) {
                break;
            }

            topWinners.push(this.generateCoin(coin));
        }

        if (coins.length > amountToShow) {
            for (let i=coins.length - 1; i > coins.length - 1 - amountToShow; i--) {
                let coin = coins[i];
                if (coin.change >= 0) {
                    break;
                }
                topLosers.push(this.generateCoin(coin));
            }
        }

        return {
            winners: topWinners,
            losers: topLosers
        };
    }

    getTopGainers(list) {
        if (list) {
            return (
                <div className="top-list top-gainers box-shadow">
                    <p className="list-title">Top gainers</p>
                    <ul className="list-group">
                        { list }
                    </ul>
                </div>
            )
        }
    }

    getTopLosers(list) {
        if (list) {
            return (
                <div className="top-list top-losers box-shadow">
                    <p className="list-title">Top losers</p>
                    <ul className="list-group">
                        { list }
                    </ul>
                </div>
            )
        }

        return null;
    }

    render() {
        let coins = this.props.coins.filter(coin => {
            return coin.change !== null;
        });
        if (!coins || coins.length === 0) {
            return null;
        }


        let topLists = this.getTopLists(coins);


        return (
            <div className="top-lists">
                { this.getTopGainers(topLists.winners) }
                { this.getTopLosers(topLists.losers) }
            </div>
        );
    }
}

export default TopLists;



// WEBPACK FOOTER //
// ./src/TopLists.js